import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { SpaceConfigPageProps } from './components/SpaceConfigPage.tsx';

export const AccessLinkSpaceAdminConfigurationLoader: LoadableType<
	Omit<SpaceConfigPageProps, 'flags'>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AccessLinkSpaceConfiguration" */ './components/SpaceConfigPage.tsx'
			)
		).SpaceConfigPage,
});
